(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gaicom-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const header = document.querySelector('.gaicom-header');
    const inner = header && header.querySelector('.gaicom-header__inner');
    if (!header || !inner) return;

    header.querySelectorAll('.gaicom-header__nav-item').forEach((item) => {
      const dropdown = item.querySelector('.gaicom-header__dropdown--grid');
      if (!dropdown) return;

      const position = () => {
        const innerRect = inner.getBoundingClientRect();
        const itemRect = item.getBoundingClientRect();
        dropdown.style.left = (innerRect.left - itemRect.left) + 'px';
        dropdown.style.width = innerRect.width + 'px';
      };

      item.addEventListener('mouseenter', position);
      item.addEventListener('focusin', position);
      window.addEventListener('resize', position);
    });
  })();

  (() => {
    const topThreshold = 4;
    const moveThreshold = 4;

    document.querySelectorAll('.gaicom-header').forEach((header) => {
      let lastY = window.scrollY;
      let ticking = false;
      const hideAfter = header.offsetHeight || 74;

      const update = () => {
        const y = window.scrollY;
        const goingDown = y > lastY;
        const delta = Math.abs(y - lastY);

        if (y <= topThreshold) {
          // 回到最顶部:实色、完全显示
          header.classList.remove('gaicom-header--hidden');
          header.classList.remove('gaicom-header--floating');
        } else if (goingDown && delta > moveThreshold && y > hideAfter) {
          // 往下滑:隐藏
          header.classList.add('gaicom-header--hidden');
        } else if (!goingDown && delta > moveThreshold) {
          // 往上滑一点:半透明浮现
          header.classList.remove('gaicom-header--hidden');
          header.classList.add('gaicom-header--floating');
        }

        lastY = y;
        ticking = false;
      };

      const onScroll = () => {
        if (!ticking) {
          window.requestAnimationFrame(update);
          ticking = true;
        }
      };

      update();
      window.addEventListener('scroll', onScroll, { passive: true });
    });
  })();

  (() => {
    const toggleBtn = document.querySelector('[data-gaicom-search-toggle]');
    const panel = document.querySelector('[data-gaicom-search-panel]');
    if (!toggleBtn || !panel) return;

    const closeBtn = panel.querySelector('[data-gaicom-search-close]');
    const input = panel.querySelector('[data-gaicom-search-input]');
    const resultsBox = panel.querySelector('[data-gaicom-search-results]');
    const popularBox = panel.querySelector('[data-gaicom-search-popular]');

    const openPanel = () => {
      panel.hidden = false;
      requestAnimationFrame(() => panel.classList.add('is-active'));
      toggleBtn.setAttribute('aria-expanded', 'true');
      window.setTimeout(() => input.focus(), 50);
    };

    const closePanel = () => {
      panel.classList.remove('is-active');
      toggleBtn.setAttribute('aria-expanded', 'false');
      window.setTimeout(() => { panel.hidden = true; }, 200);
    };

    toggleBtn.addEventListener('click', () => {
      if (panel.classList.contains('is-active')) {
        closePanel();
      } else {
        openPanel();
      }
    });

    closeBtn.addEventListener('click', closePanel);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && panel.classList.contains('is-active')) closePanel();
    });

    document.addEventListener('click', (e) => {
      if (!panel.classList.contains('is-active')) return;
      if (panel.contains(e.target) || toggleBtn.contains(e.target)) return;
      closePanel();
    });

    let debounceId = null;
    let activeController = null;

    const renderResults = (products) => {
      resultsBox.innerHTML = '';

      if (!products.length) {
        const empty = document.createElement('p');
        empty.className = 'gaicom-search-panel__result-empty';
        empty.textContent = 'No products found.';
        resultsBox.appendChild(empty);
        return;
      }

      products.forEach((product) => {
        const link = document.createElement('a');
        link.className = 'gaicom-search-panel__result';
        link.href = product.url;

        const thumb = document.createElement('span');
        thumb.className = 'gaicom-search-panel__result-thumb';
        if (product.image) {
          const img = document.createElement('img');
          img.src = product.image;
          img.loading = 'lazy';
          img.alt = product.title;
          thumb.appendChild(img);
        }

        const info = document.createElement('span');
        const title = document.createElement('span');
        title.className = 'gaicom-search-panel__result-title';
        title.textContent = product.title;
        const price = document.createElement('span');
        price.className = 'gaicom-search-panel__result-price';
        price.textContent = product.price;
        info.style.display = 'grid';
        info.style.gap = '2px';
        info.appendChild(title);
        info.appendChild(price);

        link.appendChild(thumb);
        link.appendChild(info);
        resultsBox.appendChild(link);
      });
    };

    input.addEventListener('input', () => {
      const query = input.value.trim();

      window.clearTimeout(debounceId);
      if (activeController) activeController.abort();

      if (query.length < 2) {
        resultsBox.hidden = true;
        popularBox.hidden = false;
        return;
      }

      debounceId = window.setTimeout(() => {
        activeController = new AbortController();
        const url = '/search/suggest.json?q=' + encodeURIComponent(query)
          + '&resources[type]=product&resources[limit]=6'
          + '&resources[options][fields]=title,product_type,vendor';

        fetch(url, { signal: activeController.signal })
          .then((res) => res.json())
          .then((data) => {
            const products = ((data.resources && data.resources.results && data.resources.results.products) || []).map((p) => ({
              title: p.title,
              url: p.url,
              image: p.image,
              price: p.price
            }));
            popularBox.hidden = true;
            resultsBox.hidden = false;
            renderResults(products);
          })
          .catch(() => {});
      }, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaicom-home-framework"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'gaicom-home-product-filter';

    document.querySelectorAll('.ghf').forEach((section) => {
      const buttons = Array.from(section.querySelectorAll('[data-ghf-filter-button]'));
      const cards = Array.from(section.querySelectorAll('[data-ghf-product-card]'));
      const empty = section.querySelector('[data-ghf-empty]');
      const status = section.querySelector('[data-ghf-filter-status]');
      const grid = section.querySelector('#gaicom-product-grid');
      const prevBtn = section.querySelector('[data-ghf-product-nav="prev"]');
      const nextBtn = section.querySelector('[data-ghf-product-nav="next"]');

      if (buttons.length === 0 || cards.length === 0) {
        return;
      }

      const availableFilters = buttons.map((button) => button.dataset.filter);

      const filterProducts = (filter) => {
        const activeFilter = availableFilters.includes(filter) ? filter : 'all';
        let visibleCount = 0;

        buttons.forEach((button) => {
          const isActive = button.dataset.filter === activeFilter;
          button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });

        cards.forEach((card) => {
          const tags = (card.dataset.tags || '').split(' ');
          const shouldShow = activeFilter === 'all' || tags.includes(activeFilter);
          card.hidden = !shouldShow;

          if (shouldShow) {
            visibleCount += 1;
          }
        });

        if (empty) {
          empty.hidden = visibleCount !== 0;
        }

        if (status) {
          const activeButton = buttons.find((button) => button.dataset.filter === activeFilter);
          const label = activeButton ? activeButton.textContent.trim() : 'All Seats';
          status.textContent = activeFilter === 'all'
            ? `Showing all ${visibleCount} seat styles.`
            : `Showing ${visibleCount} seat styles for ${label}.`;
        }

        try {
          localStorage.setItem(storageKey, activeFilter);
        } catch (error) {
          return;
        }
      };

      buttons.forEach((button) => {
        button.addEventListener('click', () => filterProducts(button.dataset.filter));
      });

      let initialFilter = 'all';

      try {
        initialFilter = localStorage.getItem(storageKey) || 'all';
      } catch (error) {
        initialFilter = 'all';
      }

      filterProducts(initialFilter);

      if (grid && prevBtn && nextBtn) {
        const updateNavVisibility = () => {
          const canScroll = grid.scrollWidth > grid.clientWidth + 4;
          prevBtn.hidden = !canScroll;
          nextBtn.hidden = !canScroll;
        };

        const scrollByCard = (direction) => {
          const card = grid.querySelector('[data-ghf-product-card]:not([hidden])');
          const step = card ? card.getBoundingClientRect().width + 14 : 300;
          grid.scrollBy({ left: direction === 'prev' ? -step : step, behavior: 'smooth' });
        };

        prevBtn.addEventListener('click', () => scrollByCard('prev'));
        nextBtn.addEventListener('click', () => scrollByCard('next'));
        window.addEventListener('resize', updateNavVisibility);
        updateNavVisibility();
      }

      const chips = section.querySelector('[data-ghf-chips]');
      const chipsPrevBtn = section.querySelector('[data-ghf-chips-nav="prev"]');
      const chipsNextBtn = section.querySelector('[data-ghf-chips-nav="next"]');

      if (chips && chipsPrevBtn && chipsNextBtn) {
        const updateChipsNavVisibility = () => {
          const canScroll = chips.scrollWidth > chips.clientWidth + 4;
          chipsPrevBtn.hidden = !canScroll;
          chipsNextBtn.hidden = !canScroll;
        };

        const scrollChips = (direction) => {
          const step = chips.clientWidth * 0.6;
          chips.scrollBy({ left: direction === 'prev' ? -step : step, behavior: 'smooth' });
        };

        chipsPrevBtn.addEventListener('click', () => scrollChips('prev'));
        chipsNextBtn.addEventListener('click', () => scrollChips('next'));
        chips.addEventListener('scroll', updateChipsNavVisibility);
        window.addEventListener('resize', updateChipsNavVisibility);
        updateChipsNavVisibility();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gaicom-installation-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('gaicom-dual-video')) {
    customElements.define('gaicom-dual-video', class extends HTMLElement {
      connectedCallback() {
        this.backdrop = this.querySelector('.gaicom-install__modal-backdrop');
        this.closeBtn = this.querySelector('.gaicom-install__modal-close');
        this.activePlayer = null;
        this.querySelectorAll('.gaicom-install__video-player').forEach((p) => this.initPlayer(p));

        this.closeBtn.onclick = (e) => { e.stopPropagation(); this.closeModalFullscreen(); };
        this.backdrop.onclick = (e) => { if (e.target === this.backdrop) this.closeModalFullscreen(); };
        document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeModalFullscreen(); });
      }

      initPlayer(p) {
        const v = p.querySelector('video');
        if (!v) return;

        const o = p.querySelector('.gaicom-install__video-overlay'),
              pBtn = p.querySelector('.play-toggle'),
              mBtn = p.querySelector('.mute-toggle'),
              vSlider = p.querySelector('.gaicom-install__volume-slider'),
              fBtn = p.querySelector('.full-toggle'),
              bar = p.querySelector('.gaicom-install__progress-bar'),
              curT = p.querySelector('.cur'),
              durT = p.querySelector('.dur');

        p.onclick = (e) => {
          if (e.target.closest('.gaicom-install__video-controls') || p.classList.contains('is-modal-fullscreen')) return;
          v.paused ? v.play() : v.pause();
        };

        v.onclick = (e) => {
          if (p.classList.contains('is-modal-fullscreen')) {
            v.paused ? v.play() : v.pause();
          }
        };

        pBtn.onclick = (e) => { e.stopPropagation(); v.paused ? v.play() : v.pause(); };

        vSlider.oninput = (e) => {
          v.volume = parseFloat(e.target.value);
          v.muted = (v.volume === 0);
          this.updateVolUI(v, mBtn);
        };

        mBtn.onclick = (e) => {
          e.stopPropagation();
          v.muted = !v.muted;
          vSlider.value = v.muted ? 0 : (v.volume || 1);
          this.updateVolUI(v, mBtn);
        };

        fBtn.onclick = (e) => { e.stopPropagation(); this.openModalFullscreen(p); };

        v.onplay = () => {
          o.classList.add('is-hidden');
          pBtn.querySelector('.icon-play').style.display = 'none';
          pBtn.querySelector('.icon-pause').style.display = 'block';
        };
        v.onpause = () => {
          o.classList.remove('is-hidden');
          pBtn.querySelector('.icon-play').style.display = 'block';
          pBtn.querySelector('.icon-pause').style.display = 'none';
        };
        v.onloadedmetadata = () => { durT.textContent = this.formatTime(v.duration); };
        v.ontimeupdate = () => {
          if (v.duration) {
            bar.style.width = (v.currentTime / v.duration * 100) + '%';
            curT.textContent = this.formatTime(v.currentTime);
          }
        };
      }

      updateVolUI(v, mBtn) {
        mBtn.querySelector('.icon-vol').style.display = v.muted ? 'none' : 'block';
        mBtn.querySelector('.icon-mute').style.display = v.muted ? 'block' : 'none';
      }

      formatTime(s) {
        const m = Math.floor(s / 60);
        const sec = Math.floor(s % 60);
        return m + ':' + (sec < 10 ? '0' + sec : sec);
      }

      openModalFullscreen(p) {
        this.activePlayer = p;
        this.activePlayerParent = p.parentElement;
        this.backdrop.appendChild(p);
        p.classList.add('is-modal-fullscreen');
        this.backdrop.classList.add('is-active');
        document.body.style.overflow = 'hidden';
      }

      closeModalFullscreen() {
        if (!this.activePlayer) return;
        this.activePlayerParent.appendChild(this.activePlayer);
        this.activePlayer.classList.remove('is-modal-fullscreen');
        this.backdrop.classList.remove('is-active');
        document.body.style.overflow = '';
        this.activePlayer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
